import { createEntityMock } from './mocks';
import ReduxModelGenerator from '../model-generator';
export function createMockEntity(name) {
  var throwErrorOnFetch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var exampleEntityMock = createEntityMock({
    delay: 500,
    rows: 45,
    fields: {
      foo: function foo(_ref) {
        var index = _ref.index;
        return {
          id: index,
          name: "Long text link that should be truncated ".concat(index)
        };
      },
      date: function date() {
        return new Date().getTime();
      },
      list: function list() {
        return [{
          label: 'Hello'
        }, {
          label: 'World'
        }];
      },
      tags: function tags() {
        return [{
          type: 'hot',
          label: 'Hello'
        }, {
          type: 'cold',
          label: 'World'
        }];
      },
      text: function text() {
        return 'Long text that should be truncated';
      }
    },
    itemsPerPage: 15,
    throwErrorOnFetch: throwErrorOnFetch
  }); // valueLists is required by model generator but is not required in mock

  return new ReduxModelGenerator(name, {
    entities: {
      api: exampleEntityMock.api
    }
  }).createEntityModel({});
}